import { inject } from "aurelia-dependency-injection";

import type { ILogOptions } from "../resources-vue/vue-interfaces/i-analytics";
import { AgencyService } from "../services/agency.service";

// TODO: Move all categories under this enum
export enum AnalyticsCategory {
    AxxessPlannerEditLocation = "Axxess Planner Edit Location",
    GeoLocation = "Geolocation",
    HospiceMarketing = "Hospice-Marketing-Banner",
    CovidMarketing = "Covid-Marketing",
    LineOfServiceSurvey = "Line-of-Service-Survey",
    CentralMenuPages = "Central Menu pages",
    CentralVisitActions = "Central Visit Actions",
    AxxessConnect = "Axxess Connect",
    CentralOrganizationSelect = "Central Organization select",
    CentralIntake = "Central Intake",
    AxxessPlannerVisits = "Axxess Planner Visits",
    AxxessPlannerLeftPannel = "Axxess Planner Left Pannel",
    AxxessPlannerPastDue = "Axxess Planner Past Due",
    AxxessPlannerUnreadMessages = "Axxess Planner Unread Messsages",
    AxxessPlannerPatientList = "Axxess Planner Patient list",
    AxxessPlannerAlerts = "Axxess Planner Alerts",
    AxxessPlannerNavigation = "Axxess Planner Navigation",
    CentralCalendarNavigation = "Central Calendar Navigation",
    AxxessPlannerHelpCenter = "Axxess Planner Help Center",
    Certifications = "Training and Certifications",
    Banners = "Axxess Planner Banner",
    CentralDashboard = "Central Dashboard",
    AgencyList = "Agency-List",
    FamilyPortal = "Family-Portal",
    PatientCharts = "Patient Charts",
    EmployeeSummary = "Employee summary",
    FindNearbyPatient = "Find Nearby Patient",
    EmployeeScheduleReport = "Employee Schedule Report",
    PatientScheduleReport = "Patient Schedule Report",
    ExporttoExcelforUnassignedPatientVisits = "Export to Excel for Unassigned Patient Visits"
}

@inject(AgencyService)
export class AnalyticsService {
    public agencyService: AgencyService;
    public handle: any = (window as any)._paq;

    public constructor(agencyService: AgencyService) {
        this.agencyService = agencyService;
    }

    public logEvent(options: ILogOptions): void {
        try {
            if (!this.agencyService.getIsAgencyCoreTestingUser() && !this.agencyService.getIsHomeCareTestingUser()) {
                let eventOptions = ["trackEvent", options.category, options.action];
                if (options.name) {
                    eventOptions.push(options.name);
                }
                if (options.value) {
                    eventOptions.push(options.value);
                }
                this.handle.push(eventOptions);
            }
        } catch (e) {
            console.error(e);
        }
    }
}
